import React from "react";
import { type NextPage } from "next";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { Page } from "components/page";
import { AiDecisioningHero, AidTemplate, IntroParagraph, AidInsights } from "components/platform/ai-decisioning";
import { BookDemoButton } from "components/event-tracking";
import { StackedLogos } from "components/logos";

const AiDecisioning: NextPage<LandingPageProps> = ({ page, announcementBanner, defaultLogos, customers }) => {
  return (
    <Page
      hasSmoothScroll
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      theme="dark"
      bgColor="new.violet.950"
      footerOptions={{
        variant: "violet",
        ctaProps: {
          title: "Get started today",
          description: "Ready to see AI Decisioning in action? Book a free consultation with our product experts.",
          actions: <BookDemoButton />,
        },
      }}
    >
      <AiDecisioningHero eyebrow={page.eyebrow} title={page.title} description={page.description} />
      <StackedLogos customers={defaultLogos} title="" my={0} py={{ base: "huge", md: "huger" }} />
      <AidInsights />
      <IntroParagraph />
      <AidTemplate customers={customers} />
    </Page>
  );
};

export const getStaticProps = getLandingPageProps("/platform/ai-decisioning", {
  loadDefaultLogos: true,
  loadCustomers: ["whoop"],
});

export default AiDecisioning;
